import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { KeyGatePage, LoginPage, TwoFactorPage } from "./pages/AuthPages";
import { Dashboard } from "./pages/Dashboard";
import { Settings } from "./pages/Settings";
import { ProtectedRoute, KeyGateRoute, LoginRoute, TwoFactorRoute } from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <KeyGateRoute>
                  <KeyGatePage />
                </KeyGateRoute>
              }
            />
            <Route
              path="/login"
              element={
                <LoginRoute>
                  <LoginPage />
                </LoginRoute>
              }
            />
            <Route
              path="/2fa"
              element={
                <TwoFactorRoute>
                  <TwoFactorPage />
                </TwoFactorRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
